import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Input,
  Spin,
  Select,
  InputNumber,
  Divider,
  Space,
  DatePicker,
  Modal,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import { save } from "../../../../features/save/saveSlice";
import dayjs from "dayjs";
import IwuaLicenseTable from "./dynamic-license/IwuaLicenseTable";

const IwuaAdd = ({ isModalOpen, handleCancel, handleFetch, prodd }) => {
  const urlLicense = "sch/get_institution_licences";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[urlLicense] || [],
    count: state.fetch.count[urlLicense] || 0,
  }));
  const [dataSource, setDataSource] = useState(data);
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { counties, schemeCrop, iwuaLicenses } = useSelector(
    (state) => state.fetch
  );

  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["asalSchemes"],
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const onFinish = async (data) => {
    const licences = dataSource?.map(item => ({
      lcId: item?.lcId,
      lcType: item?.licType,   
      lcInstId: item?.lcInstId, 
      lcPath: item?.lcPath,
      lcLicId: item?.licId, 
    })) || [];

    data.instId = prodd?.instId ? prodd?.instId : null;
    data.instSchId = activeObjSchemes?.schId;
    data.instCrops = Array.isArray(data?.instCrops)
      ? data?.instCrops.join(",")
      : data?.instCrops;
    // data.instLicense = Array.isArray(data?.instLicense)
    //   ? data?.instLicense.join(",")
    //   : data?.instLicense;

    const res = await dispatch(
      save({
        licences,
        ...data,
        url: "sch/institution",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch();
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };
  useEffect(() => {
    if (prodd) {
      form.setFieldsValue({
        ...prodd,
        instRegCertDate: prodd?.instRegCertDate
          ? dayjs(new Date(prodd?.instRegCertDate))
          : null,
      });
    } else {
      form.resetFields();
    }
  }, [prodd, form]);

  useEffect(() => {
    setDataSource(data);
  }, [data]); 
  return (
    <Modal
      title={"Add IWUA"}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[61.5rem]"
      maskClosable={false}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <div className="custom-title !p-0 !bg-white mt-[2.69rem]">
          IWUA Details
        </div>

        <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
          <Form.Item
            name="instName"
            label={"IWUA Name"}
            rules={[
              {
                required: true,
                message: "Please add Iwua name",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
 
          <Form.Item
            name="instRegCertDate"
            rules={[
              {
                required: false,
                message: "Field is required",
              },
            ]}
            label="Registration Date"
          >
            <DatePicker format={"YYYY MMM DD"} className="input" />
          </Form.Item>

          <Form.Item
            name="instLocation"
            label={"Physical Location"}
            rules={[
              {
                required: true,
                message: "Please add physical Location",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>

          <Form.Item
            label="Major Crops"
            name="instCrops"
            rules={[{ required: true, message: "Required field" }]}
          >
            <Select
              mode="multiple"
              allowClear
              showSearch
              dropdownRender={(menu) => (
                <>
                  <Space style={{ padding: "8px 8px 4px" }}>
                    <span className="select-info mt-1">
                      Choose one or more of the following crops
                    </span>
                  </Space>
                  <Divider style={{ margin: "8px 0" }} />
                  {menu}
                </>
              )}
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children?.toLowerCase() ?? "").includes(
                  input.toLowerCase()
                )
              }
              tagRender={(props) => {
                const { label, closable, onClose } = props;
                return (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      padding: "4px 8px",
                      margin: "2px",
                      borderRadius: "4px",
                      background: "#f5f5f5",
                    }}
                  >
                    {label}
                    {closable && (
                      <span
                        onClick={onClose}
                        style={{
                          marginLeft: "8px",
                          cursor: "pointer",
                          color: "red",
                        }}
                      >
                        ×
                      </span>
                    )}
                  </span>
                );
              }}
              dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
            >
              {schemeCrop?.length > 0 &&
                schemeCrop?.map((item) => (
                  <Select.Option key={item?.blkcId} value={item?.blkcCrop}>
                    {item?.blkcCrop}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </div>

        <div className="custom-title !p-0 !bg-white mt-[2.5rem]">
          Contact Person
        </div>

        <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
          <Form.Item
            name="instContName"
            label={"Name"}
            rules={[
              {
                required: true,
                message: "Please add name",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
          <Form.Item
            name="instContIdNumber"
            label="ID Number"
            rules={[
              {
                required: false,
                message: "National ID is required",
              },
              {
                validator(_, value) {
                  if (value && value.toString().length < 6) {
                    return Promise.reject(
                      "National ID must be at least 6 characters long"
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <InputNumber
              min={0}
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
            />
          </Form.Item>

          <Form.Item
            name="instContEmail"
            label={"Email"}
            rules={[
              {
                required: false,
                message: "Please add email address",
              },
              {
                type: "email",
                message: "Please enter a valid email address",
              },
            ]}
          >
            <Input type="email" className="input" />
          </Form.Item>
          <Form.Item
            name="instContPhone"
            label={"Active Phone Number"}
            rules={[
              {
                required: true,
                message: "Please add primary phone no",
              },
            ]}
          >
            <PhoneInput
              country="ke"
              onlyCountries={["ke"]}
              countryCodeEditable={false}
              className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
            />
          </Form.Item>
        </div>

        <div className="custom-title !p-0 !bg-white mt-[2.5rem]">Licenses</div>
        <IwuaLicenseTable
          dataSource={dataSource}
          setDataSource={setDataSource}
        />

        <div className="flex justify-between ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? <Spin /> : prodd?.instId ? "Update" : "Create"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default IwuaAdd;
